import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Component({
  selector: 'app-signin-callback',
  templateUrl: './signin-callback.component.html',
  styleUrls: ['./signin-callback.component.sass'],
})
export class SigninCallbackComponent implements OnInit {
  constructor(private readonly _router: Router, private _authService: AuthenticationService) {}

  ngOnInit() {
    this._authService
      .signinCallback()
      .then((result: any) => {
        console.log(new Date().toLocaleString() + '  ➤  === signin callback result ===', result);
      })
      .catch((err: any) => {
        console.log(new Date().toLocaleString() + '  ➤  === signin callback error ===', err);
      })
      .finally(() => {
        // In any case it should redirect to login page
        this._router.navigate(['/login']);
      });
  }
}
